function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("g", null, React.createElement("path", {
  fill: "#EBEDEE",
  d: "M228,136.8c0,8.396-6.806,15.2-15.2,15.2H15.2C6.806,152,0,145.195,0,136.8V15.2C0,6.805,6.806,0,15.2,0 h197.6c8.395,0,15.2,6.805,15.2,15.2V136.8z"
}), React.createElement("path", {
  fill: "#E67E22",
  d: "M213.256,152c8.395,0,14.744-6.014,14.744-14.408V92.715c0,0-58.359,41.285-166.079,59.285H213.256z"
}), React.createElement("path", {
  opacity: 0.1,
  fill: "#231F20",
  d: "M228.229,92.715c0,0-58.588,41.69-166.308,59.69 C190.452,152.405,228.229,92.715,228.229,92.715z"
}), React.createElement("g", null, React.createElement("path", {
  fill: "#231F20",
  d: "M24.334,45.766H15.22v31.83h9.065c4.821,0,8.302-1.137,11.357-3.675c3.631-3.004,5.778-7.534,5.778-12.218 C41.421,52.309,34.402,45.766,24.334,45.766z M31.587,69.677c-1.951,1.762-4.485,2.531-8.497,2.531h-1.666V51.159h1.666 c4.012,0,6.446,0.718,8.497,2.574c2.147,1.912,3.438,4.875,3.438,7.924C35.025,64.712,33.734,67.766,31.587,69.677z"
}), React.createElement("rect", {
  x: 44.278,
  y: 45.766,
  fill: "#231F20",
  width: 6.208,
  height: 31.83
}), React.createElement("path", {
  fill: "#231F20",
  d: "M65.668,57.98c-3.726-1.379-4.819-2.288-4.819-4.007c0-2.005,1.949-3.528,4.625-3.528 c1.86,0,3.39,0.764,5.007,2.578l3.248-4.254c-2.669-2.335-5.863-3.529-9.354-3.529c-5.631,0-9.927,3.911-9.927,9.121 c0,4.385,2,6.63,7.831,8.729c2.431,0.857,3.668,1.428,4.292,1.812c1.24,0.81,1.861,1.957,1.861,3.293 c0,2.579-2.051,4.49-4.82,4.49c-2.962,0-5.347-1.48-6.776-4.245l-4.011,3.862c2.86,4.199,6.296,6.06,11.021,6.06 c6.451,0,10.978-4.29,10.978-10.452C74.823,62.852,72.73,60.563,65.668,57.98z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M76.782,61.703c0,9.356,7.347,16.611,16.801,16.611c2.673,0,4.962-0.525,7.784-1.855V69.15 c-2.482,2.484-4.68,3.486-7.495,3.486c-6.253,0-10.691-4.534-10.691-10.979c0-6.111,4.579-10.932,10.402-10.932 c2.962,0,5.203,1.057,7.784,3.582v-7.306c-2.725-1.382-4.966-1.955-7.638-1.955C84.323,45.046,76.782,52.448,76.782,61.703z"
}), React.createElement("polygon", {
  fill: "#231F20",
  points: "150.596,67.146 142.107,45.766 135.324,45.766 148.833,78.412 152.174,78.412 165.924,45.766  159.194,45.766  "
}), React.createElement("polygon", {
  fill: "#231F20",
  points: "168.732,77.596 186.34,77.596 186.34,72.208 174.936,72.208 174.936,63.615 185.92,63.615  185.92,58.224 174.936,58.224 174.936,51.159 186.34,51.159 186.34,45.766 168.732,45.766  "
}), React.createElement("path", {
  fill: "#231F20",
  d: "M210.923,55.163c0-5.959-4.104-9.397-11.265-9.397h-9.206v31.83h6.201V64.809h0.81l8.594,12.787h7.636 l-10.021-13.409C208.349,63.235,210.923,60.037,210.923,55.163z M198.467,60.42h-1.813v-9.641h1.912 c3.867,0,5.969,1.62,5.969,4.718C204.534,58.697,202.433,60.42,198.467,60.42z"
}), React.createElement("circle", {
  fill: "#E67E22",
  cx: 120.328,
  cy: 61.791,
  r: 16.933
})));

var SvgPayDiscover = function SvgPayDiscover(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "228.229px",
    height: "152.405px",
    viewBox: "0 0 228.229 152.405",
    preserveAspectRatio: "xMinYMin meet",
    enableBackground: "new 0 0 228.229 152.405",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPayDiscover, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pay-discover.196aaadb.svg";
export { ForwardRef as ReactComponent };